import type { FlightLogSectionContext } from '../useFlightLogForm'
import { NumRow, TextRow } from '../../ui/prntr-fields'
import { PrntrAutoRow, PrntrGroup } from '../../ui/prntr-input'

export function FuelSection({
  context,
  fuelUsed,
}: {
  context: FlightLogSectionContext
  fuelUsed: number | null
}) {
  const { control, readOnly, fieldError } = context
  return (
    <PrntrGroup>
      <NumRow
        control={control}
        name="fuel.plannedUpliftL"
        label="Planned Uplift"
        suffix="LTS"
        readOnly={readOnly}
        error={fieldError('fuel.plannedUpliftL')}
      />
      <NumRow
        control={control}
        name="fuel.actualUpliftL"
        label="Actual Uplift"
        suffix="LTS"
        readOnly={readOnly}
        error={fieldError('fuel.actualUpliftL')}
      />
      <TextRow
        control={control}
        name="fuel.fuelDocNo"
        label="Fuel Doc No"
        readOnly={readOnly}
        error={fieldError('fuel.fuelDocNo')}
      />
      <NumRow
        control={control}
        name="fuel.departTotalLbs"
        label="Depart Total (lbs)"
        suffix="LBS"
        readOnly={readOnly}
        error={fieldError('fuel.departTotalLbs')}
      />
      <NumRow
        control={control}
        name="fuel.arrivalTotalLbs"
        label="Arrival Total (lbs)"
        suffix="LBS"
        readOnly={readOnly}
        error={fieldError('fuel.arrivalTotalLbs')}
      />
      <PrntrAutoRow label="Fuel Used" value={fuelUsed !== null ? String(fuelUsed) : null} suffix="LBS" />
    </PrntrGroup>
  )
}
